import BasicField from './basic'

export class StringField extends BasicField {
  value() {
    return this.applyVariables()
  }
}

export default StringField